import React, { ReactNode } from 'react'
import { ClientPublicWrapper } from './client/ClientPublicWrapper'
import { ContractorPortalPublicWrapper } from './contractorPortal/ContractorPortalPublicWrapper'
import { BasePublicWrapper } from './BasePublicWrapper'

interface Props {
  flow?: 'client' | 'recollect' | 'contractorPortal'
  children?: ReactNode
}

export const PublicWrapper = ({ flow, children }: Props) => {
  if (flow === 'client') {
    return <ClientPublicWrapper children={children} />
  }

  if (flow === 'contractorPortal') {
    return <ContractorPortalPublicWrapper children={children} />
  }

  return <BasePublicWrapper children={children} />
}
